import * as React from 'react'

export default class Pond extends React.PureComponent {
	render() {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 1 1"
				className="Canvas-pond"
				preserveAspectRatio="none"
			>
				<path
					d=" M 0 0.5 C 0 0.224 0.224 0 0.5 0 C 0.776 0 1 0.224 1 0.5 C 1 0.776 0.776 1 0.5 1 C 0.224 1 0 0.776 0 0.5 Z "
					fill="rgb(0,0,255)"
				/>
			</svg>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Pond.js